import React from 'react';
import RenderError from './RenderError';
import Notice from '../../../../components/Notice';

function NaturalDisasterQuestion({ formData, setFormData, errors }) {
  return (
    <>
      <div className="form__field form__field--required">
        <label className="form__label">
          Has your farm operation recently been impacted by a natural disaster?
        </label>
        <div className="form__select form__select--lg">
          <select
            defaultValue={formData.naturalDisaster}
            onChange={(event) => {
              let newFormData = formData;
              delete newFormData.zipcode;
              setFormData({
                ...newFormData,
                naturalDisaster: event.target.value
              });
            }}
          >
            <option value="0">No</option>
            <option value="1">Yes</option>
          </select>
        </div>
        {errors.natural_disaster && (
          <RenderError error={errors.naturalDisaster} />
        )}
      </div>
      {formData.naturalDisaster === '1' && (
        <>
          <div className="form__field form__field--required">
            <label className="form__label u--margin-right-20" htmlFor="zipcode">
              Zip Code:
            </label>
            <input
              type="text"
              name="zipcode"
              value={formData.zipcode ?? ''}
              className="form__input form__input--lg"
              onChange={(event) =>
                setFormData({ ...formData, zipcode: event.target.value })
              }
            />
            {errors.zipcode && <RenderError error={errors.zipcode} />}
          </div>
          <Notice message="We will review your application and if you qualify for natural disaster relief your incentive amount will be double." />
        </>
      )}
    </>
  );
}

export default NaturalDisasterQuestion;
